import type { CSSProperties, ReactNode } from 'react'
import React from 'react'
import classNames from 'classnames'

import type { Icon } from '@slite/icons'

import {
  DEFAULT_CLASSES,
  labelSizesClassNames,
  labelSizesStyles,
  labelVariantsClasses,
} from './constants'

export type BaseLabelProps = {
  variant?: keyof typeof labelVariantsClasses
  size?: keyof typeof labelSizesStyles
  isDisabled?: boolean
  className?: string
  children: (
    className: string,
    style: CSSProperties,
    renderFn: (children: ReactNode) => ReactNode
  ) => ReactNode
  style?: React.CSSProperties
  icon?: Icon
  iconClassName?: string
  uppercase?: boolean
}

export const BaseLabel = ({
  variant = 'primary',
  isDisabled = false,
  className,
  children: renderFn,
  style,
  icon: LabelIcon,
  iconClassName,
  size = 'regular',
  uppercase = true,
}: BaseLabelProps) => {
  const _className = classNames(
    DEFAULT_CLASSES,

    isDisabled
      ? labelVariantsClasses[variant]?.isDisabled
      : labelVariantsClasses[variant]?.default,

    className,
    labelSizesClassNames[size],
    {
      uppercase,
      'line-height-large': !className?.includes('line-height-'),
      'font-size-smaller': !className?.includes('font-size-'),
      'font-weight-bold': !className?.includes('font-weight-'),
    }
  )

  const baseStyle = labelSizesStyles[size]
  return (
    <>
      {renderFn(_className, { ...baseStyle, ...style }, (children) => (
        <>
          {LabelIcon && (
            <LabelIcon
              size={14}
              className={classNames('flexbox-no-shrink', iconClassName, {
                'margin-right-8': !iconClassName?.includes('margin-right-'),
              })}
            />
          )}
          <span className="ellipsis">{children}</span>
        </>
      ))}
    </>
  )
}
